/**
 * Validation rules used in validation.js
 */


const validationRules = (() => {
    let _matching = {};

    /**
     * Set rule-logic matching
     */
    const init = () => {
        _matching = {
            required: required,
            phone: phone,
            name: name,
            email: email,
            file: file,
            size: size,
            nip: nip,
            postalCode: postalCode
        };
    };

    /**
     * Return matching rule
     * @param rule
     */
    const returnValidationRule = (rule) => {
        //TODO: add some element check/ parsing
        rule = rule.trim();
        return _matching[rule];
    };

    /**
     * required field validation test. Sometimes it can be a boolean value
     *
     * @param {String|Boolean|Array} value
     * @returns {boolean}
     */
    const required = (value, type) => {
        if (type !== "checkbox")
            value = value.replace(/\s+/g, '');

        if (!value) {
            return {
                error: true,
                msg: "Pole jest wymagane"
            };
        }

        return {error: false};
    };

    /**
     * input file size validation test.
     *
     * @returns {boolean}
     */

    const size = (value, type, size) => {
        const validSize = 2097152;

        return size <= validSize ?
            {error:false} :
            {
                error:true,
                msg: 'Zbyt duży rozmiar pliku'
            }
    };

    /**
     * input image file validation test.
     *
     * @returns {boolean}
     */
    const file = (value, type) => {
        const validExt = ["application/pdf", "image/png", "image/jpg", "image/jpeg"];

        return (validExt.includes(value)) ?
            {error: false} :
            {
                error: true,
                msg: 'Błędny format pliku'
            };
    };

    /**
     * Name/surname validation test
     *
     * @param {String} value
     * @returns {Boolean}
     */
    const name = (value) => {
        return (/^[a-zżźćńółęąś\s\-]+$/i.test(value)) ? {error: false} : {
            error: true,
            msg: 'Pole może zawierać tylko litery'
        };
    };

    const email = (value) => {
        let polishLetters = /[ąĄćĆęĘłŁńŃóÓśŚźŹżŻ]/;

        if (value.indexOf("@") > -1) {
            let name = value.split('@')[0];

            if (name.length > 64) {
                return {
                    error: true,
                    msg: 'Podany e-mail jest nieprawidłowy'
                };
            }
        }

        if (value.match(polishLetters) !== null) {
            return {
                error: true,
                msg: 'Podany e-mail jest nieprawidłowy'
            };
        }

        if (!value) {
            return {
                error: true,
                msg: 'Podany e-mail jest nieprawidłowy'
            };
        }

        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? {error: false} : {
            error: true,
            msg: 'Podany e-mail jest nieprawidłowy'
        };

    };

    const phone = (value) => {
        return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(value) ? {error: false} : {
            error: true,
            msg: "Podany numer telefonu jest nieprawidłowy"
        };
    };

    const nip = ( nip ) => {
        if ( !nip ) {
            return true;
        }

        nip = nip.replace( /-/g, "" ); // nip without dashes

        const reg = /^[0-9]{10}$/;

        if ( !reg.test( nip ) ) {
            return {
                error: true,
                msg  : 'Podany numer NIP jest nieprawidłowy'
            };
        }

        const dig = ( "" + nip ).split( "" );

          const control = (
          6 * parseInt( dig[0] ) +
          5 * parseInt( dig[1] ) +
          7 * parseInt( dig[2] ) +
          2 * parseInt( dig[3] ) +
          3 * parseInt( dig[4] ) +
          4 * parseInt( dig[5] ) +
          5 * parseInt( dig[6] ) +
          6 * parseInt( dig[7] ) +
          7 * parseInt( dig[8] )
        ) % 11;


        if ( parseInt( dig[9] ) === control ) {
            return { error: false };
        }

        return {
            error: true,
            msg  : 'Podany numer NIP jest nieprawidłowy'
        };
    };

    const postalCode = ( value ) => {
        return  /^[0-9]{2}\-[0-9]{3}$/.test( value ) ? { error: false } : {
            error: true,
            msg  : "Błędny kod pocztowy"
        };
    };

    return {
        init: init,
        returnValidationRule: returnValidationRule
    };
})();

export {validationRules}
